import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material';
import { SharedModule } from '../../shared/shared.module';
import { AuthRoutingModule } from './auth.routing';

@NgModule({
    imports: [
        SharedModule,
        MatCardModule,
       AuthRoutingModule
    ],
    providers: [],
    bootstrap: []
})
export class AuthModule {}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/auth/auth.module.ts